import {PetitionSignatureRefDTO} from "./types";
import axios from 'axios';

export function handleCrowdFundForm(petitionSignature: PetitionSignatureRefDTO) {
    return {
        amount: '',
        setAndSubmit(v: string|number) {
            this.amount = v; // as input string number most likely
            this.track();
            this.donateIntent();
            setTimeout(() => {
                this.$refs.crowdfund_form.submit();
            }, 0);
        },
        donateIntent() {
            axios.patch(`/petitions/${petitionSignature.petition.slug}/crowdfund_intent`, {
                'petition_signature_id': petitionSignature.id,
                'value': this.amount
            });
        },
        track() {
            if (this.amount === '') {
                this.amount = 10;
            }
            if (typeof gtag !== 'undefined') {
                gtag('event', 'crowdfunder_checkout', {
                    'event_label': petitionSignature.petition.name,
                    'event_category': 'petition',
                    'value': this.amount,
                    'currency': 'GBP'
                });
            }
        },
        onSubmit() {
            this.track();
            this.donateIntent();
        }
    };
}
